import React from "react";
import "./FinalApprover.scss"
import { FinalApproverContextProvider } from "../../features/FinalApproverForm/FinalApproverConext";
import FinalApproverForm from "../../features/FinalApproverForm/FinalApproverForm";

const FinalApprover = () => {
  return (
    <div className="page-container">
      <FinalApproverContextProvider>
        <FinalApproverForm />
      </FinalApproverContextProvider>
    </div >

  );
};
export default FinalApprover;
